<template>
  <div @contextmenu.prevent.stop="onContextmenu">
    <sj-question-file :disabled="disabled">
      <sj-question-file-progress v-for="(item, index) in progress"
                                 :key="'percentage' + index"
                                 :percentage="item.percentage"></sj-question-file-progress>
      <sj-question-file-item v-for="(file, index) in files"
                             :key="'file' + index"
                             icon="el-icon-service"
                             :disabled="disabled"
                             :show-hover-icons="showHoverIcons"
                             @view="view(file.src)"
                             @contextmenu.prevent.stop.native="(event)=>{onContextmenu(event, index)}"
                             @remove="remove(index)"
                             :selected="checkedFiles.includes(file)"></sj-question-file-item>
      <el-tooltip
        effect="dark"
        :content="title"
        placement="top">
        <sj-question-file-add :disabled="disabled || files.length > 0"
                              @click="$refs.selectFile.click()"></sj-question-file-add>
      </el-tooltip>
    </sj-question-file>
    <input ref="selectFile"
           v-if="!disabled"
           v-show="false"
           type="file"
           accept=".mp3"
           @change="upload">
  </div>
</template>

<script>
import SjQuestionFile from '@/views/question-editor/packages/sj-question-file'
import SjQuestionFileItem from '@/views/question-editor/packages/sj-question-file-item'
import SjQuestionFileAdd from '@/views/question-editor/packages/sj-question-file-add'
import SjQuestionFileProgress from '@/views/question-editor/packages/sj-question-file-progress'
import ContextMenu from '@/views/question-review/components/ContextMenu'

export default {
  components: {SjQuestionFileProgress, SjQuestionFileAdd, SjQuestionFileItem, SjQuestionFile},
  mixins: [],
  inject: ['playAudio'],
  props: {
    value: Array,
    disabled: Boolean,
    title: {
      type: String,
      default: '添加指引音频'
    },
    showHoverIcons: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      progress: [
        // percentage: 0,
      ],
      checkedFiles: []
    }
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    view (src) {
      this.playAudio({src})
    },
    upload () {
      let file = this.$refs.selectFile.files[0]
      if (this.validate(file)) {
        // 显示进度条
        let progress = {
          percentage: 0,
          file: file,
        }
        this.progress.push(progress)
        // 生成请求数据
        let form = new FormData()
        form.append('file', file)
        request.alert('uploadStepTemplateFile', form, {
          onUploadProgress: progressEvent => {
            progress.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0)
          }
        }).then(({data}) => {
          this.files.push({src: data})
        }).finally(() => {
          this.progress.splice(this.progress.indexOf(progress), 1)
        })
      }
      this.$refs.selectFile.value = null
    },
    validate (file) {
      const size = 10
      const isLtSize = file.size / 1024 / 1024 < size
      if (!isLtSize) {
        this.$message.error(`上传音频大小不能超过 ${size}MB!`)
      }
      return isLtSize
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    onContextmenu ({clientX, clientY}, index) {
      // 匹配右击菜单作用域
      ContextMenu().scope !== this.uniqueId && ContextMenu().empty()
      // 判断右击是否在项目上
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        if (!this.checkedFiles.includes(file)) {
          ContextMenu().empty()
          ContextMenu().checked(file)
          this.checkedFiles = ContextMenu().checkedFiles
        }
      } else {
        ContextMenu().empty()
      }
      // 限制拷贝数量
      ContextMenu({pasteMax: Number.MAX_SAFE_INTEGER})
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/SjQuestionGuideAudio.vue